import {
  BACKGROUND,
  CARD,
  CardDefinition,
  LayoutListDefinition,
  LAYOUT_LIST
} from '../items';
import { Translator } from '../Translator';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { OPTIONAL_TEXT_FIELDS } from '../utils/optionalFields';

export const Images7: Translator = sequence => {
  const root = translate(sequence, item => {
    if (item.__typename === 'Text') {
      return {
        id: `${item.id}-toplist`,
        type: LAYOUT_LIST,
        values: {
          align: 'center'
        },
        items: [
          {
            id: `${item.id}-card`,
            type: CARD,
            values: {
              width: '80%',
              height: 'auto',
              padded: true
            },
            items: [
              {
                id: `${item.id}-list`,
                type: LAYOUT_LIST,
                values: {
                  align: 'center'
                },
                items: TextHelper(item as ItemOfType<'Text'>, {
                  optional: OPTIONAL_TEXT_FIELDS
                })
              } as LayoutListDefinition
            ]
          } as CardDefinition
        ]
      } as LayoutListDefinition;
    }

    return null;
  });

  if (!root.items.some(item => item.type === BACKGROUND)) {
    root.items.unshift({
      id: 'boxed-image-background',
      type: BACKGROUND,
      values: { value: 'var(--color-pink-lt)', opacity: 100 },
      items: []
    });
  }

  return root;
};
